import { redirect, error } from "@sveltejs/kit";
import { type } from "arktype";
import { a as formDataToObject } from "./utils2.js";
function requireUserMiddleware(event) {
  if (!event.locals.user) {
    const queryString = new URLSearchParams({
      goto: event.url.pathname
    }).toString();
    redirect(307, `/sign-in?${queryString}`);
  }
  return (
    /** @type {User} */
    event.locals.user
  );
}
async function validateBodyMiddleware(schema, event) {
  const formData = await event.request.formData();
  const body = formDataToObject(formData);
  const validated = schema(body);
  if (validated instanceof type.errors) {
    error(400, validated.summary);
  }
  return (
    /** @type {Exclude<ReturnType<T>, import('arktype').ArkErrors>} */
    validated
  );
}
export {
  requireUserMiddleware as r,
  validateBodyMiddleware as v
};
